var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _vm.$store.getters.isKiosk
      ? _c("div")
      : _c(
          "div",
          { staticClass: "page noselect" },
          [
            _c("div", { staticClass: "fixBg maxw" }),
            _c(
              "div",
              { staticStyle: { "z-index": "2", position: "relative" } },
              [
                _c(
                  "v-container",
                  {
                    staticStyle: { "margin-bottom": "-10px" },
                    attrs: { "grid-list-md": "" },
                  },
                  [
                    _c(
                      "v-layout",
                      { attrs: { row: "", wrap: "" } },
                      [
                        _c("v-flex", { attrs: { xs12: "" } }, [
                          _c(
                            "div",
                            { staticClass: "logoContainer pt-8 pb-8" },
                            [
                              _c("img", {
                                staticStyle: { "max-height": "200px" },
                                attrs: {
                                  src: require("../assets/placeholder6-opti.png"),
                                },
                              }),
                            ]
                          ),
                        ]),
                        _vm.showOrderModeSwitcher
                          ? _c("v-flex", { attrs: { xs12: "" } }, [
                              _c(
                                "div",
                                { staticClass: "pt-5 pb-5" },
                                [_c("OrderModeSwitcher")],
                                1
                              ),
                            ])
                          : _vm._e(),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "" } },
                          [
                            _c("CmsBlock", {
                              attrs: { blockName: "Startseite Oben" },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { staticClass: "pb-3 d-flex", attrs: { xs6: "" } },
                          [
                            _c("CategoryCard", {
                              staticClass: "pointer",
                              attrs: {
                                label: "Speisen",
                                nomargin: false,
                                icon: "mdi-silverware-fork-knife",
                              },
                              nativeOn: {
                                "&click": function ($event) {
                                  return _vm.gotoSpeisen.apply(null, arguments)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _c(
                          "v-flex",
                          { staticClass: "pb-3 d-flex", attrs: { xs6: "" } },
                          [
                            _c("CategoryCard", {
                              staticClass: "pointer",
                              attrs: {
                                label: "Getränke",
                                nomargin: false,
                                icon: "mdi-beer",
                              },
                              nativeOn: {
                                "&click": function ($event) {
                                  return _vm.gotoDrinks.apply(null, arguments)
                                },
                              },
                            }),
                          ],
                          1
                        ),
                        _vm.$store.getters.inhouse &&
                        _vm.$store.state.enableKellnerruf
                          ? _c(
                              "v-flex",
                              {
                                staticClass: "pb-3 d-flex",
                                attrs: { xs12: "" },
                              },
                              [
                                _c("CategoryCard", {
                                  staticClass: "pointer",
                                  attrs: {
                                    label: "Kellnerruf",
                                    nomargin: false,
                                    pngicon: "waiter",
                                    inverse: true,
                                  },
                                  nativeOn: {
                                    "&click": function ($event) {
                                      return _vm.goKellnerruf.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.$store.getters.enableStempel
                          ? _c(
                              "v-flex",
                              {
                                staticClass: "pb-3 d-flex",
                                attrs: { xs12: "" },
                              },
                              [
                                _c("CategoryCard", {
                                  staticClass: "pointer",
                                  attrs: {
                                    bg: "Stempelkarte",
                                    label: "Stempelkarte",
                                    nomargin: false,
                                    pngicon: "StempelkartenIcon",
                                  },
                                  nativeOn: {
                                    "&click": function ($event) {
                                      return _vm.$ebus.$emit("goto", {
                                        name: "Stempelkarte",
                                      })
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.$store.getters.inhouse &&
                        (_vm.$store.getters.enableTakeawayPay ||
                          _vm.$store.getters.enableTakeawayOhnePay)
                          ? _c(
                              "v-flex",
                              {
                                staticClass: "pb-3 d-flex",
                                attrs: { xs12: "" },
                              },
                              [
                                _c("CategoryCard", {
                                  staticClass: "pointer",
                                  attrs: {
                                    label: "Abholzeiten",
                                    nomargin: false,
                                    icon: "mdi-clock-outline",
                                  },
                                  nativeOn: {
                                    "&click": function ($event) {
                                      return _vm.$ebus.$emit("goto", {
                                        name: "Abholzeiten",
                                      })
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.$store.getters.inhouse &&
                        (_vm.$store.getters.enableDeliveryPay ||
                          _vm.$store.getters.enableDeliveryOhnePay)
                          ? _c(
                              "v-flex",
                              {
                                staticClass: "pb-3 d-flex",
                                attrs: { xs12: "" },
                              },
                              [
                                _c("CategoryCard", {
                                  staticClass: "pointer",
                                  attrs: {
                                    label: "Lieferzeiten",
                                    nomargin: false,
                                    icon: "mdi-clock-outline",
                                  },
                                  nativeOn: {
                                    "&click": function ($event) {
                                      return _vm.$ebus.$emit("goto", {
                                        name: "Lieferzeiten",
                                      })
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        !_vm.$store.getters.inhouse &&
                        (_vm.$store.getters.enableDeliveryPay ||
                          _vm.$store.getters.enableDeliveryOhnePay)
                          ? _c(
                              "v-flex",
                              {
                                staticClass: "pb-3 d-flex",
                                attrs: { xs12: "" },
                              },
                              [
                                _c("CategoryCard", {
                                  staticClass: "pointer",
                                  attrs: {
                                    label: "Liefergebiet",
                                    nomargin: false,
                                    icon: "mdi-map-marker-radius",
                                  },
                                  nativeOn: {
                                    "&click": function ($event) {
                                      return _vm.$ebus.$emit(
                                        "gotoPage",
                                        "Liefergebiet"
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.$store.state.enableNews
                          ? _c(
                              "v-flex",
                              {
                                staticClass: "pb-3 d-flex",
                                attrs: { xs12: "" },
                              },
                              [
                                _c("CategoryCard", {
                                  staticClass: "pointer",
                                  attrs: {
                                    label: "Aktuelles",
                                    nomargin: false,
                                    icon: "mdi-bell",
                                  },
                                  nativeOn: {
                                    "&click": function ($event) {
                                      return _vm.gotoAktuelles.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.$store.getters.lastOrders.length > 0
                          ? _c(
                              "v-flex",
                              {
                                staticClass: "pb-3 d-flex",
                                attrs: { xs12: "" },
                              },
                              [
                                _c("CategoryCard", {
                                  staticClass: "pointer",
                                  attrs: {
                                    label: "Meine Bestellungen",
                                    nomargin: false,
                                    icon: "mdi-history",
                                  },
                                  nativeOn: {
                                    "&click": function ($event) {
                                      return _vm.gotoLastOrders.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _vm.showInstall
                          ? _c(
                              "v-flex",
                              {
                                staticClass: "pb-3 d-flex",
                                attrs: { xs12: "" },
                              },
                              [
                                _c("CategoryCard", {
                                  staticClass: "pointer",
                                  attrs: {
                                    label: "App installieren",
                                    nomargin: false,
                                    icon: "mdi-exit-to-app",
                                  },
                                  nativeOn: {
                                    "&click": function ($event) {
                                      return _vm.clickInstallApp.apply(
                                        null,
                                        arguments
                                      )
                                    },
                                  },
                                }),
                              ],
                              1
                            )
                          : _vm._e(),
                        _c(
                          "v-flex",
                          { attrs: { xs12: "" } },
                          [
                            _c("CmsBlock", {
                              attrs: { blockName: "Startseite Unten" },
                            }),
                          ],
                          1
                        ),
                      ],
                      1
                    ),
                    _c("div", { staticClass: "logoPadding" }),
                  ],
                  1
                ),
              ],
              1
            ),
            _c("FixBasket"),
          ],
          1
        ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }